import { LocalRole } from "@core/model/local-role.enum";
import { useUserIdentity } from "@core/services/user-identity.hook";
import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface ProtectedRoleRouteProps {
  children: ReactNode;
  allowedRoles: LocalRole[];
}

const ProtectedRoleRoute: React.FC<ProtectedRoleRouteProps> = ({
  allowedRoles,
  children,
}) => {
  const { getUserRole } = useUserIdentity();
  const { name } = getUserRole();
  if (!allowedRoles.includes(name.toUpperCase() as LocalRole)) {
    return <Navigate to="/404" replace />;
  }
  return <>{children}</>;
};

export default ProtectedRoleRoute;
